export const fetchMake = () => {
    return fetch(
        `${process.env.NEXT_PUBLIC_ACKODRIVE_WORKSPACE_BASE_URL}/car-valuation/v1/acko-make-data/`
    )
        .then((res) => {
            return res.json();
        })
        .then((pres) => {
            return pres;
        });
};

export const fetchModels = (make_id: string) => {
    return fetch(
        `${process.env.NEXT_PUBLIC_ACKODRIVE_WORKSPACE_BASE_URL}/car-valuation/v1/acko-model-data/?make_id=${make_id}`
    )
        .then((res) => {
            return res.json();
        })
        .then((pres) => {
            return pres;
        });
};

export const fetchVariants = (model_id: string) => {
    return fetch(
        `${process.env.NEXT_PUBLIC_ACKODRIVE_WORKSPACE_BASE_URL}/car-valuation/v1/acko-variant-data/?model_id=${model_id}`
    )
        .then((res) => {
            return res.json();
        })
        .then((pres) => {
            return pres;
        });
};
